import React from "react";
import styles from "./footer.module.scss";
import { useNavigate } from "react-router-dom";
import GoogleMapComponent from "../contactUs/map";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={styles["container"]}>
        <div className={styles["footer-top"]}>
          <div className={styles["footer-left"]}>
            <img
              draggable={false}
              src="./img/gray-logo.png"
              alt="Meraki Logo"
            />
          </div>
          <div className={styles["footer-right"]}>
            <div className={styles["footer-right-item"]}>
              <h5>Quick Links</h5>
              <label
                onClick={() => {
                  navigate("/contact");
                }}
              >
                Contact
              </label>
              <label>
                <a
                  href="https://instagram.com/merakiloungesd?igshid=MzRlODBiNWFlZA=="
                  rel="noreferrer"
                  target="_blank"
                >
                  Visit Us On Instagram
                </a>
              </label>
              <label>
                <a
                  href="https://www.facebook.com/LawaMerakiSalon/"
                  rel="noreferrer"
                  target="_blank"
                >
                  Visit Us On Facebook
                </a>
              </label>
            </div>
            <div className={styles["footer-right-item"]}>
              <h5>Meraki Lounge Links</h5>
              <label
                onClick={() => {
                  navigate("/services");
                }}
              >
                Book a Service
              </label>
              <label>
                <a
                  href="https://abundanceextensions.com/"
                  rel="noreferrer"
                  target="_blank"
                >
                  Shop Extensions
                </a>
              </label>
              {/* <label>
                <a href="tel:+1 (619) 535-7828">+1 (619) 535-7828</a>
              </label> */}
            </div>
            <div className={`${styles["footer-right-item"]} ${styles["info-only"]}`}>
              <span className={styles["footer-heading"]}>Meraki Lounge Info</span>
              <div className={styles["info-block"]}>
                <p>Sunday & Monday — CLOSED</p>
                <p>Tuesday – Friday — 9:00am – 7:00pm</p>
                <p>Saturday — 10:00am – 6:00pm</p>
              </div>
              <span className={styles["footer-heading"]}>Address</span>
              <p>
                <a
                  href="https://www.google.com/maps/place/Lawa+Meraki/@32.709126,-117.1552452,21z/data=!4m6!3m5!1s0x80d95358e188793b:0x6a28a3c166a9e1d3!8m2!3d32.7091321!4d-117.1553064!16s%2Fg%2F11c61btvw1?entry=ttu"
                  rel="noreferrer"
                  target="_blank"
                >
                  369 10th Ave. San Diego, CA 92101
                </a>
              </p>
              <span className={styles["footer-heading"]}>Phone</span>
              <p>
                <a href="tel:+1 (619) 535-7828">+1 (619) 535-7828</a>
              </p>
            </div>
            <div className={styles["footer-right-item"]}>
              <h5>Location</h5>
              <div className={styles["footer-map"]}>
                <GoogleMapComponent
                  center={{ lat: 32.7091321, lng: -117.1553064 }}
                  zoom={13}
                  height="200px"
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles["footer-bottom"]}>
          <p>All Rights Reserved {new Date().getFullYear()} &copy;</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
